import { stringToDate } from './stringToDate';
// To be replaces with checkRange()
export const checkMinMax = (min, max, value) => {
    var _a, _b, _c;
    const v = (_a = stringToDate(value)) === null || _a === void 0 ? void 0 : _a.getTime();
    const mi = (_b = stringToDate(min)) === null || _b === void 0 ? void 0 : _b.getTime();
    const ma = (_c = stringToDate(max)) === null || _c === void 0 ? void 0 : _c.getTime();
    if (mi > ma) {
        return mi >= v && v >= ma; // Reversed min-max
    }
    return mi <= v && v <= ma;
};
//# sourceMappingURL=checkMinMax.js.map